
import {Component, Prop, Watch} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import LoaderMixin from '@/mixins/LoaderMixin';
import SuccessIcon from '@/components/Icons/SuccessIcon.vue';
import InfoIcon from '@/components/Icons/InfoIcon.vue';
import ErrorIcon from '@/components/Icons/ErrorIcon.vue';
import DialogConfirmIcon from '@/components/Icons/DialogConfirmIcon.vue';
@Component({
  components: {DialogConfirmIcon, ErrorIcon, InfoIcon, SuccessIcon},
})
export default class DialogConfirm extends mixins(LoaderMixin) {
  @Prop() value!: boolean;
  @Prop({default: 'Confirmation'}) title!: string;
  @Prop({default: 'Are you sure want to confirm this action?'})
  message!: string;
  @Prop({default: 'Cancel'}) cancelText!: string;
  @Prop({default: 'Confirm'}) confirmText!: any;
  @Prop({default: '500px'}) maxWidth!: any;
  @Prop({default: 'primary'}) color!: string;
  @Prop({default: ''}) icon!: string;
  @Prop({default: false}) noCancel!: boolean;
  @Prop({default: false}) noTitle!: boolean;
  @Prop({default: false}) center!: boolean;
  @Prop({default: () => ({})}) cardProps!: any;
  @Prop({
    default: () => ({
      color: 'primary',
    }),
  })
  btnConfirmProps!: any;

  innerValue = true;

  get centerClass() {
    return {
      'text-center': this.center,
    };
  }

  @Watch('value', {immediate: true})
  onValueChanged(value: any) {
    this.innerValue = value;
  }

  mounted() {
    document.addEventListener('keyup', this.onEnterPressed);
  }

  destroyed() {
    document.removeEventListener('keyup', this.onEnterPressed);
  }

  onEnterPressed(e: KeyboardEvent) {
    const key = e.key || e.keyCode;
    if (key === 13) {
      e.stopPropagation();
      this.choose(true);
    }
  }

  choose(value: any) {
    if (value) this.$emit('confirmed', value);
    this.innerValue = value;
    this.$destroy();
  }

  change() {
    this.$destroy();
  }
}
